module.exports = __webpack_public_path__ + "img/藏茴香.55cccb93.jpg";